module.exports = __webpack_public_path__ + "img/28.b73fb1e1.jpg";